var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-base"},[_c('app-header'),_c('app-banner'),_c('NonprofitForm',{attrs:{"enable-nonprofit-search":true}}),_c('shared-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }